import { TASK_STATUS, TASK_TYPE } from './task';
import { GEOGRAPHICAL_MAP } from 'utils/constants/Map';
import { SITE_POLICY_DEFAULT_VALUES } from 'utils/constants/visitor';

export const MAINTENANCE_OPERATIONAL_TASK_TYPE_FILTER = [
  {
    id: TASK_TYPE.MAINTENANCE.id,
    name: TASK_TYPE.MAINTENANCE.name,
  },
];

export const SUBTASK_MAINTENANCE_DEFAULT = {
  taskType: TASK_TYPE.MAINTENANCE.id,
  isTemplate: false,
  wrapsId: null,
  scanCode: null,
  scanAutoStart: null,
  scanStartOnly: null,
  surfaceViewPreferred: true,
  status: TASK_STATUS.NEW.id,
  siteSurfaceImages: GEOGRAPHICAL_MAP,
};

export const TASK_WORKORDER_DEFAULT = {
  isTemplate: false,
  wrapsId: null,
  scanCode: null,
  scanAutoStart: null,
  scanStartOnly: null,
  surfaceViewPreferred: true,
  status: TASK_STATUS.NEW.id,
  taskName: '',
  siteSurfaceImages: GEOGRAPHICAL_MAP,
  newBusinessClient: false,
  severityRating: 'NOT_RATED',
  ...SITE_POLICY_DEFAULT_VALUES,
};
